import React from 'react';
import TabsComponent from '../../../components/Tabs/Tabs';
import { MasterBidding } from '../../Reusables/Bidding/MasterBidding/bidding';
import { BundleBid } from '../../Reusables/Bidding/BundleBidding/BundleBid';
import { BidRequest } from '../../Reusables/Bidding/BidRequest/BidRequest';
import BiddingControl from './Control';
import { useQueryParamWithDefault } from '../../../hooks';
import { NumberParam } from 'use-query-params';
import { SymetricalBundle } from '../../Reusables/Bidding/SymetricalBundle/SymetricalBundle';
import { ResourceSchedule } from '../../Reusables/Bidding/ResourceSchedule/resourceSchedule';

const Bidding = ({ cId }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('tab', NumberParam, 0, cId);
    const tabs = [
        {
            name: 'Bidding',
            component: <MasterBidding heading={'Master Bidding'} />,
            tabId: 1,
        },
        {
            name: 'Bundle Bidding',
            component: <BundleBid heading={'Master Bidding'} />,
            tabId: 2,
        },
        {
            name: 'Linked Bundle',
            component: <SymetricalBundle />,
            tabId: 3,
        },
        {
            name: 'Bid Request',
            component: <BidRequest />,
            tabId: 4,
        },
        {
            name: 'Control',
            component: <BiddingControl />,
            tabId: 5,
        },
        {
            name: 'Resource Schedule',
            component: <ResourceSchedule />,
            tabId: 6,
        },
    ];

    return (
        <div className={'ventilation'}>
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

export default Bidding;
